<template>
  <v-menu
          offset-overflow
          fixed
          max-height="300"
          :position-y="position.y"
          :position-x="position.x"
          :value="true"
          :z-index="1"
          :close-on-content-click="false"
          @input="$emit('dismiss')"
  >
    <v-card class="mx-auto pt-2" max-width="400" tile>
      <v-list-tile v-if="searcher">
        <v-text-field :label="$t('message.searcher.label')" v-model="searchText"></v-text-field>
      </v-list-tile>
      <v-divider v-if="searcher"></v-divider>
      <v-list-tile class="blot-item" v-for="(blot, i) in availableBlots" :key="i">
        <v-list-tile-content @click="$emit('selected', blot)">
          <v-list-tile-title>{{ $t(`message.editor.embed.${blot.blotName}`) }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-card>
  </v-menu>
</template>

<script>
import normalizeText from '@/plugins/normalize-text';

export default {
  name: 'nx-blot-dropdown',
  props: {
    blots: Array,
    position: Object,
    searcher: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchText: null,
    };
  },
  computed: {
    availableBlots() {
      if (this.searchText) {
        return this.searchBlots();
      }

      return this.blots;
    },
  },
  methods: {
    searchBlots() {
      const searchableBlots = this.blots.map(b => ({ ...b, searchableName: this.$t(`message.editor.embed.${b.blotName}`) }));

      const regex = new RegExp(this.searchText, 'i');
      return searchableBlots.filter(blot => regex.test(normalizeText(blot.searchableName)));
    },
  },
};
</script>


<style lang="stylus">
  .blot-item {
    cursor: pointer;
  }
</style>
